import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Input, OnChanges, SimpleChanges, ViewChild } from "@angular/core";

@Component({
    selector: 'show-more',
    templateUrl: './show-more.component.html',
    styleUrls: ['./show-more.component.scss'],
    standalone: false
}) export class ShowMoreComponent implements AfterViewInit, OnChanges {
  @Input() lines = 1;
  @Input() text = '';

  @ViewChild('content') contentRef!: ElementRef<HTMLDivElement>;

  triggerVisible = false;
  contentHidden = true;

  constructor(private cdRef: ChangeDetectorRef) {}

  ngAfterViewInit(): void {
    this.resolveContentVisibility();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['text'] && !changes['text'].firstChange) {
      this.contentHidden = true;

      this.resolveContentVisibility();
    }
  }

  toggleVisibility(): void {
    this.contentHidden = !this.contentHidden;
  }

  private resolveContentVisibility(): void {
    setTimeout(() => {
      const { clientHeight, scrollHeight } = this.contentRef.nativeElement;
  
      this.triggerVisible = clientHeight < scrollHeight;
      this.contentHidden = this.triggerVisible;
  
      this.cdRef.markForCheck();
    });
  }

}